// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class UsersWithSiteAccountRequestModel {
    static getAttributeTypeMap() {
        return UsersWithSiteAccountRequestModel.attributeTypeMap;
    }
}
UsersWithSiteAccountRequestModel.discriminator = undefined;
UsersWithSiteAccountRequestModel.additionalProperties = false;
UsersWithSiteAccountRequestModel.attributeTypeMap = [
    {
        "name": "portalId",
        "baseName": "portalId",
        "type": "string"
    },
    {
        "name": "connectionName",
        "baseName": "connectionName",
        "type": "string"
    },
];
//# sourceMappingURL=usersWithSiteAccountRequestModel.js.map